import SliderBoundlessPcMobile from './SliderBoundlessPcMobile';
export default SliderBoundlessPcMobile;
